import serviceHandler from "@/helpers/handlers/service";
import externalChanges from "@/services/externalChanges";
import { moduleCheck } from "@/helpers/module-check";
import { Module } from "@/enums/modules";
import ErrorHandler from "@/helpers/handlers/error";

export default {
  async fetchProtectionSummary({ commit, dispatch, rootState }) {
    const { company } = rootState.company;
    if (
      moduleCheck(Module.EXTERNAL_CHANGES_PROTECT) &&
      !!company &&
      !company.enabled_auto_gmb_external_changes_protection
    ) {
      const data = await serviceHandler(externalChanges.getProtectionSummary());
      commit("SET_SUMMARY", data);
    } else {
      dispatch("reset");
    }
  },

  async rejectChanges({ commit, getters }) {
    if (getters.changesIds.length) {
      commit("SET_LOADING", true);
      try {
        await externalChanges.rejectChanges(getters.changesIds);
        commit("SET_LOADING", false);
        return true;
      } catch (error) {
        ErrorHandler.displayError(error);
        commit("SET_LOADING", false);
        return false;
      }
    }
  },

  reset({ commit }) {
    commit("SET_SUMMARY", null);
  }
};
